import { render, staticRenderFns } from "./ProductScrollVertical.vue?vue&type=template&id=7688c1ae&scoped=true&"
import script from "./ProductScrollVertical.vue?vue&type=script&lang=js&"
export * from "./ProductScrollVertical.vue?vue&type=script&lang=js&"
import style0 from "./ProductScrollVertical.vue?vue&type=style&index=0&id=7688c1ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7688c1ae",
  null
  
)

export default component.exports